/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { useEffect, useState } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AnyAction } from 'redux';
import PostCard from '../../components/postCard';
import { getPosts, getNextPosts } from '../../redux/slices/analytics/postsList';
import {
  getUserDetails,
  updateDisplayMode
} from '../../redux/slices/user/userDetails';
import InfiniteScroll from 'react-infinite-scroll-component';
import IsUpdatingIndicator from '../../components/isUpdatingIndicator';
import IsLoadingIndicator from '../../components/isLoadingIndicator';
import { ChangeDisplayMode } from '../../components/changeDisplayMode';
import { PostsFilter } from '../../components/postsFilter';
import { useLocales } from '../../locales';

const PostsList: React.FC = () => {
  const dispatch = useDispatch();
  const { translate: t } = useLocales();
  const { isUpdating, count, posts, isLoading } = useSelector(
    (state: any) => state.postsList
  );
  const { displayMode } = useSelector((state: any) => state.userDetails);
  const { locationslug, status } = useParams();
  const [pageNumber, setPageNumber] = useState(0);
  const getMorePosts = (): void => {
    setTimeout(() => {
      dispatch(getNextPosts(pageNumber + 1) as unknown as AnyAction);
      setPageNumber(pageNumber + 1);
    }, 10);
  };
  useEffect(() => {
    dispatch(getUserDetails() as unknown as AnyAction);
    dispatch(
      getPosts(locationslug, status, {
        ordering: options[status as keyof typeof options][0].key
      }) as unknown as AnyAction
    );
    setPageNumber(pageNumber + 1);
  }, [dispatch]);
  const changeDisplayMode = (display: number): void => {
    if (display === 0) dispatch(updateDisplayMode(1) as unknown as AnyAction);
    else dispatch(updateDisplayMode(0) as unknown as AnyAction);
  };
  const options = {
    ready: [
      {
        text: 'published',
        desc: 'new_to_old',
        key: '-latest_upload_to_platform_timestamp'
      },
      {
        text: 'published',
        desc: 'old_to_new',
        key: 'latest_upload_to_platform_timestamp'
      },
      {
        text: 'created',
        desc: 'new_to_old',
        key: '-created'
      },

      {
        text: 'created',
        desc: 'old_to_new',
        key: 'created'
      }
    ],
    draft: [
      {
        text: 'created',
        desc: 'new_to_old',
        key: '-created'
      },

      {
        text: 'created',
        desc: 'old_to_new',
        key: 'created'
      },
      {
        text: 'edited',
        desc: 'new_to_old',
        key: '-modified'
      },
      {
        text: 'edited',
        desc: 'old_to_new',
        key: 'modified'
      }
    ],
    'waiting-for-approval': [
      {
        text: 'created',
        desc: 'new_to_old',
        key: '-created'
      },

      {
        text: 'created',
        desc: 'old_to_new',
        key: 'created'
      },
      {
        text: 'edited',
        desc: 'new_to_old',
        key: '-modified'
      },
      {
        text: 'edited',
        desc: 'old_to_new',
        key: 'modified'
      }
    ]
  };

  return (
    <Container fluid>
      <div className="d-flex flex-end align-items-center">
        <PostsFilter
          location={locationslug}
          status={status}
          options={options[status as keyof typeof options]}
        />
        <div className="m-2" />
        <ChangeDisplayMode
          small={true}
          display={displayMode === 1}
          setDisplay={(ds: boolean) => {
            changeDisplayMode(displayMode);
          }}
          title={'list_view'}
        />
      </div>

      <div className="d-flex flex-end">
        {isUpdating ? <IsUpdatingIndicator /> : ''}
      </div>
      <div className="d-flex flex-center">
        {isLoading && !isUpdating ? <IsLoadingIndicator /> : ''}
      </div>

      {posts.length === 0 ? (
        <div className="d-flex flex-center my-6">
          {t('no_content_available')}
        </div>
      ) : (
        <InfiniteScroll
          dataLength={posts.length}
          next={getMorePosts}
          hasMore={count > posts.length}
          loader={<IsLoadingIndicator />}
        >
          <ResponsiveMasonry
            columnsCountBreakPoints={{
              576: 1,
              768: 2,
              992: 2,
              1200: 3,
              1400: 4
            }}
          >
            <Masonry>
              {posts.map((post: any, i: number) => {
                return <PostCard key={i} post={post} />;
              })}
            </Masonry>
          </ResponsiveMasonry>
        </InfiniteScroll>
      )}
    </Container>
  );
};
export default PostsList;
